module.exports = __webpack_public_path__ + "img/type10020.67d17031.png";